import { useTranslation } from "react-i18next";
import { useKycFormOpen } from "@features/KnowYourCustomerNotification/utils";
import { Button } from "@components/Button";
import { parseHtml } from "@components/HTMLParser/utils";
import { Notification } from "@components/Notification/Notification";
import { useCustomerMetadataQuery } from "@services/customer/queries";
import { BeforePaymentAction } from "@services/payments/types";

export const FilloutKycWithAntiMoneyLaunderingFormNotification: React.FC =
  () => {
    const { data: metadata } = useCustomerMetadataQuery();
    const { t } = useTranslation();
    const { isPrefetching, open: openKycForm } = useKycFormOpen();

    const isCorrectWarning =
      metadata?.beforePaymentAction ===
      BeforePaymentAction.FilloutKycWithAntiMoneyLaunderingForm;

    const handleButtonClick = () => {
      void openKycForm();
    };

    if (!isCorrectWarning) {
      return null;
    }

    return (
      <Notification
        color="purple"
        imagePath="/images/notification/bill-icon.png"
        variant="big"
        title={t("filloutKycWithAntiMoneyLaunderingFormNotification.title")}
        description={
          parseHtml(
            t("filloutKycWithAntiMoneyLaunderingFormNotification.description"),
          ) as string
        }
        button={
          <Button onClick={handleButtonClick} isLoading={isPrefetching}>
            {t("filloutKycWithAntiMoneyLaunderingFormNotification.button")}
          </Button>
        }
      />
    );
  };
